export default "de17cb83f08f75ea8cfbd3c9682a8429.svg";